import React from "react";
import LeaderShipSection from "../../components/AboutUs/Leadership/LeaderShipSection.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const Alliances: React.FC = () => {
  return (
    <div>
      <MetaComponent
        title="Leadership Team at Aptech Limited"
        desc="Explore Aptech’s leadership team, dedicated to dynamic growth for students, faculty, and business partners in the education sector worldwide."
        keywords="aptech leadership team, aptech success stories, aptech business partners"
      />
      <LeaderShipSection />
    </div>
  );
}

export default Alliances;
